import { Component } from '../../types-common';
import IconButtonStyled from './IconButton.styled';

interface IconButtonProps {
  onClick: (event: any) => void;
}
export const IconButton: Component<IconButtonProps> = ({ onClick, children }) => (
  <IconButtonStyled onClick={onClick}>{children}</IconButtonStyled>
);
